import {Injectable} from '@angular/core';
import moment from 'moment';

@Injectable({providedIn: 'root'})
export class UtilsInjectable {
  date(value: any): string {
    if (!value) return value;
    return moment.utc(value).format('DD-MM-Y');
  }

  datetime(value: any): string {
    if (!value) return value;
    return moment.utc(value).format('D-MM-Y hh:mm a');
  }


  buildArray(length: any): number[] {
    return Array.from({length}, (_, i) => i)
  }

  dropConfig(options: any) {
    return {
      limitTo: 10,
      moreText: '.........',
      noResultsFound: 'No results found!',
      searchPlaceholder: 'Search',
      search: true,
      height: '200px',
      position: 'auto',
      ...options
    }
  }

}
